export default function LoadingSpinner({ texto = 'Carregando...' }) {
    return (
        <div style={{ textAlign: 'center', padding: '48px', color: '#888' }}>
            <div style={{
                width: '36px', height: '36px',
                border: '3px solid #e0e0e0',
                borderTop: '3px solid #1B4F72',
                borderRadius: '50%',
                animation: 'spin 0.8s linear infinite',
                margin: '0 auto 12px',
            }} />
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            <p>{texto}</p>
        </div>
    );
}
